import {
  Table,
  Input,
  message,
  Spin,
  Modal,
  Tooltip,
  Button,
  Avatar,
  DatePicker,
  Dropdown,
  Select,
  Popover,
  Card,
  Upload,
} from "antd";
import { RiDragMove2Fill, RiInboxArchiveLine, RiLayoutGridFill } from "react-icons/ri";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  CalendarOutlined,
  DeleteOutlined,
  DownOutlined,
  FileOutlined,
  FilePdfOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import {
  FaBriefcase,
  FaCheckCircle,
  FaFlag,
  FaHourglassHalf,
  FaPen,
  FaTrashAlt,
} from "react-icons/fa";
import React from "react";
import {
  deleteDocument,
  deleteProject,
  archiveProject,
  restoreProject,
  deleteProjectSummary,
  getallProject,
  getProjectByID,
  updateProject,
  updateProjectOrder,
  getProjectStats,
  getallDeveloperForTask,
  API,
} from "../../utils/API";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { autoRegisterCurrentPageColumns } from "../../utils/emailTemplateColumns";
import { hasPermission } from "../../utils/HasPermission";
import AddProjectModal from "./Add";
import EditProjectModal from "./Edit";
import dayjs, { Dayjs } from "dayjs";
import { AuthContext } from "../../Auth/AuthContext";
import { MdOutlineRestore } from "react-icons/md";
import { HiOutlineDocumentText } from "react-icons/hi";
import { BsCheck2Circle } from "react-icons/bs";

// Define the Developer interface based on API response
interface Project {
  _id: string;
  clientId: { name: string; profilePhoto?: string };
  assignees: any[];
  projectName: string;
  budget: number;
  review: string;
  endingDate: string | Date | null;
  completionDate: string | Date;
  startDate: string | Date;
  isActive: boolean;
  isonhold?: boolean;
  iscompleted?: boolean;
  purposal?: string[];
  contract?: string[];
}

interface ProjectStats {
  totalProjects: number;
  activeProjects: number;
  onHoldProjects: number;
  completedProjects: number;
  deletedProjects: number;
}

export const ProjectsTable = () => {
  const IMAGEURL = process.env.REACT_APP_IMAGE_URL + "/customers/";
  const PHOTOURL = process.env.REACT_APP_IMAGE_URL + "/developers/";

  const [activeTab, setActiveTab] = useState<
    "all" | "active" | "onhold" | "completed" | "archived"
  >("active");

  const [stats, setStats] = useState<ProjectStats>({
    totalProjects: 0,
    activeProjects: 0,
    onHoldProjects: 0,
    completedProjects: 0,
    deletedProjects: 0,
  });

  const [archivedProjects, setArchivedProjects] = useState<Project[]>([]);
  const [archiveRecord, setArchiveRecord] = useState<Project | null>(null);
  const [restoreId, setRestoreId] = useState<string | null>(null);

  const [dataSource, setDataSource] = useState<Project[]>([]);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentTask, setCurrentTask] = useState<Project | null>(null);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDocModalVisible, setIsDocModalVisible] = useState(false);
  const [developers, setDevelopers] = useState<any[]>([]);
  const [openAssigneeId, setOpenAssigneeId] = useState<string | null>(null);
  const [tempAssigneeIds, setTempAssigneeIds] = useState<string[]>([]);
  const [selectedDocs, setSelectedDocs] = useState<{
    purposal?: string[];
    contract?: string[];
  }>({});

  const today = dayjs();
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryData, setSummaryData] = useState<any[]>([]);
  const [currentSummaryprojectId, setCurrentSummaryprojectId] = useState<
    string | null
  >(null);
  const [newSummary, setNewSummary] = useState<{
    date: Dayjs | null;
    description: string;
    nextActionDate: Dayjs | null;
  }>({
    date: dayjs(),
    description: "",
    nextActionDate: dayjs(),
  });
  const [newPurposalFiles, setNewPurposalFiles] = useState<any[]>([]);
  const [newContractFiles, setNewContractFiles] = useState<any[]>([]);
  const { authData } = useContext(AuthContext);
  const user_id = authData.user._id;

  const handleViewSummary = async (projectId: string) => {
    setCurrentSummaryprojectId(projectId);
    setIsSummaryModalOpen(true);
    setSummaryLoading(true);

    try {
      const res = await getProjectByID(projectId);
      setSummaryData(res?.summaries || []);
    } catch (err) {
      console.error("Error fetching summary:", err);
      setSummaryData([]);
    } finally {
      setSummaryLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const res = await getProjectStats();
      if (res?.success && res.data) {
        setStats({
          totalProjects: res.data.total,
          activeProjects: res.data.active,
          onHoldProjects: res.data.onHold,
          completedProjects: res.data.completed,
          deletedProjects: res.data.archived,
        });
      }
    } catch (err) {
      console.error("Error fetching stats:", err);
    }
  };

  const fetchProject = async () => {
    setLoading(true);
    try {
      const response: any = await getallProject(searchText, page, activeTab, pageSize);

      if (response?.data) {
        setDataSource(response.data);
        setTotalRecords(response.totalCount || 0);
      } else {
        setDataSource([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  useEffect(() => {
    fetchProject();
  }, [page, searchText, activeTab, pageSize]);

  useEffect(() => {
    getallDeveloperForTask("", "")
      .then((res: any) => setDevelopers(res?.data || []))
      .catch(() => {});
  }, []);

  const handleEditClick = (record: Project) => {
    setCurrentTask(record);
    setIsEditModalVisible(true);
  };

  const handleDelete = async () => {
    if (deleteId) {
      try {
        if (activeTab === "archived") {
          await deleteProject(deleteId);
          message.success("Project permanently deleted");
        } else {
          await archiveProject(deleteId);
          message.success("Project moved to archived");
        }
        fetchProject();
        fetchStats();
      } catch (error) {
        console.error("Delete Error:", error);
        message.error(
          activeTab === "archived"
            ? "Error permanently deleting project."
            : "Error archiving project.",
        );
      } finally {
        setDeleteId(null);
      }
    }
  };

  const handleRestore = async () => {
    if (restoreId) {
      try {
        await restoreProject(restoreId);
        fetchProject();
        fetchStats();
        message.success("Project restored successfully");
      } catch (error) {
        console.error("Restore Error:", error);
        message.error("Error restoring project.");
      } finally {
        setRestoreId(null);
      }
    }
  };

  const handleStatusChange = async (
    projectId: string,
    nextStatus: "active" | "onhold" | "completed",
    record: Project,
  ) => {
    try {
      // Issue #5: Backend update route uses multer multipart parser,
      // so JSON bodies are ignored. Send FormData to persist status.
      const formData = new FormData();
      formData.append("isActive", String(nextStatus === "active"));
      formData.append("isonhold", String(nextStatus === "onhold"));
      formData.append("iscompleted", String(nextStatus === "completed"));
      (record.purposal || []).forEach((f: string) =>
        formData.append("purposalExisting", f)
      );
      (record.contract || []).forEach((f: string) =>
        formData.append("contractExisting", f)
      );
      await updateProject(projectId, formData, user_id);
      const tabMessages: Record<string, string> = {
        active: "Project set to Active!",
        onhold: "Project set to On Hold!",
        completed: "Project marked Completed!",
      };
      message.success(tabMessages[nextStatus] || "Status updated!");
      fetchStats();
      fetchProject();
    } catch (error) {
      console.error("Error updating project status:", error);
      message.error("Failed to update status.");
    }
  };

  const handleAssigneeUpdate = async (projectId: string, record: Project, newAssigneeIds: string[]) => {
    if (newAssigneeIds.length === 0) {
      message.warning("Please select at least one assignee");
      return;
    }
    try {
      const formData = new FormData();
      newAssigneeIds.forEach(id => formData.append("assignees[]", id));
      record.purposal?.forEach((f: string) => formData.append("purposalExisting", f));
      record.contract?.forEach((f: string) => formData.append("contractExisting", f));
      await updateProject(projectId, formData, user_id);
      message.success("Assignees updated successfully!");
      fetchProject();
      setOpenAssigneeId(null);
    } catch (error) {
      console.error(error);
      message.error("Failed to update assignees.");
    }
  };

  // Issue #1: Save documents (proposals + contracts) from Documents Modal
  const handleSaveDocuments = async () => {
    const projectId = (selectedDocs as any)._id || currentTask?._id;
    if (!projectId) {
      message.error("No project selected");
      return;
    }
    try {
      const formData = new FormData();
      newPurposalFiles.forEach((f) => {
        if (f.originFileObj) formData.append("purposal", f.originFileObj);
      });
      newContractFiles.forEach((f) => {
        if (f.originFileObj) formData.append("contract", f.originFileObj);
      });
      (selectedDocs.purposal || []).forEach((f: string) =>
        formData.append("purposalExisting", f)
      );
      (selectedDocs.contract || []).forEach((f: string) =>
        formData.append("contractExisting", f)
      );
      await updateProject(projectId, formData, user_id);
      message.success("Documents updated successfully");
      setNewPurposalFiles([]);
      setNewContractFiles([]);
      setIsDocModalVisible(false);
      fetchProject();
    } catch (error) {
      console.error("Error updating documents:", error);
      message.error("Failed to update documents");
    }
  };

  // Issue #3: Drag-and-drop project reordering
  const handleDragEnd = async (result: any) => {
    if (!result.destination) return;
    if (result.destination.index === result.source.index) return;

    const newDataSource = Array.from(dataSource);
    const [moved] = newDataSource.splice(result.source.index, 1);
    newDataSource.splice(result.destination.index, 0, moved);
    setDataSource(newDataSource);

    const orderedIds = newDataSource.map((p) => p._id);
    try {
      await updateProjectOrder(orderedIds);
      message.success("Project order updated");
    } catch (error) {
      console.error("Error updating project order:", error);
      message.error("Failed to update project order");
      fetchProject(); // revert by re-fetching
    }
  };

  const StatusBadge = ({ record }: { record: Project }) => {
    let status = "Active";
    let statusKey: "active" | "onhold" | "completed" = "active";
    let color = "text-emerald-600 bg-white border-emerald-100 cursor-pointer hover:bg-emerald-50";
    let dotColor = "bg-emerald-500";

    if (
      activeTab !== "archived" &&
      (
        record.iscompleted === true ||
        (record.iscompleted === undefined && Boolean(record.endingDate))
      )
    ) {
      status = "Completed";
      statusKey = "completed";
      color = "text-purple-600 bg-white border-purple-100 cursor-pointer hover:bg-purple-50";
      dotColor = "bg-purple-500";
    } else if (
      activeTab === "archived" ||
      record.isonhold === true ||
      (record.isonhold === undefined && !record.isActive)
    ) {
      status = "On Hold";
      statusKey = "onhold";
      color = "text-orange-600 bg-white border-orange-100 cursor-pointer hover:bg-orange-50";
      dotColor = "bg-orange-500";
    }

    return (
      <Dropdown
        trigger={["click"]}
        disabled={!hasPermission("projects", "update")}
        menu={{
          selectedKeys: [statusKey],
          items: [
            {
              key: "active",
              label: (
                <span className="flex items-center gap-2 text-[12px] font-semibold text-emerald-600">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                  Active
                </span>
              ),
            },
            {
              key: "onhold",
              label: (
                <span className="flex items-center gap-2 text-[12px] font-semibold text-orange-600">
                  <span className="h-1.5 w-1.5 rounded-full bg-orange-500" />
                  On Hold
                </span>
              ),
            },
            {
              key: "completed",
              label: (
                <span className="flex items-center gap-2 text-[12px] font-semibold text-purple-600">
                  <span className="h-1.5 w-1.5 rounded-full bg-purple-500" />
                  Completed
                </span>
              ),
            },
          ],
          onClick: ({ key }) => {
            if (key !== statusKey) {
              handleStatusChange(
                record._id,
                key as "active" | "onhold" | "completed",
                record,
              );
            }
          },
        }}
      >
        <button
          type="button"
          className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-bold shadow-sm transition-all ${color}`}
        >
          <span className={`h-1 w-1 rounded-full ${dotColor}`} />
          {status}
          <DownOutlined className="ml-0.5 text-[8px] opacity-70" />
        </button>
      </Dropdown>
    );
  };

  const compareText = (first?: string, second?: string) =>
    (first || "").localeCompare(second || "", undefined, {
      sensitivity: "base",
    });

  const compareDates = (first?: string | Date | null, second?: string | Date | null) => {
    const firstDate = first ? dayjs(first).valueOf() : 0;
    const secondDate = second ? dayjs(second).valueOf() : 0;

    return firstDate - secondDate;
  };

  const getAssigneeName = (user: any) =>
    user?.username || user?.name || "N/A";

  const getAssigneeInitial = (user: any) =>
    getAssigneeName(user).charAt(0).toUpperCase();

  const getStatusSortValue = (project: Project) => {
    if (
      project.iscompleted === true ||
      (project.iscompleted === undefined && Boolean(project.endingDate))
    ) return 3;
    if (
      project.isonhold === true ||
      (project.isonhold === undefined && !project.isActive)
    ) return 2;
    return 1;
  };

  const columns = [
    // Issue #3: Drag handle column (only for non-archived tabs)
    ...(activeTab !== "archived"
      ? [{
          title: "",
          key: "dragHandle",
          width: 36,
          fixed: "left" as const,
          // The row itself is Draggable; this column shows the grip icon.
          // The drag handle is integrated into the row via dragHandleProps (see DraggableRow).
          render: () => (
            <Tooltip title="Drag to reorder">
              <span className="drag-handle-cell inline-flex items-center justify-center w-full h-full cursor-grab active:cursor-grabbing">
                <RiDragMove2Fill className="text-slate-400" style={{ fontSize: 16 }} />
              </span>
            </Tooltip>
          ),
        }]
      : []),
    {
      title: "#",
      key: "serialNumber",
      width: 60,
      fixed: "left" as const,
      render: (_: any, __: any, index: number) => (
        <span className="text-slate-500 text-[13px]">{(page - 1) * pageSize + (index + 1)}</span>
      ),
    },
    {
      title: "Client",
      dataIndex: "clientId",
      width: 220,
      fixed: "left" as const,
      sorter: (first: Project, second: Project) =>
        compareText(first.clientId?.name, second.clientId?.name),
      render: (client: any) => (
        <div className="flex items-center gap-3">
          <Avatar
            src={client?.profilePhoto ? `${IMAGEURL}${client.profilePhoto}` : "/download.png"}
            size={32}
            className="border border-slate-100 shadow-sm shrink-0"
          >
            {client?.name?.charAt(0)}
          </Avatar>
          <span className="text-slate-700 font-medium text-[13px] truncate">
            {client?.name || "N/A"}
          </span>
        </div>
      ),
    },
    {
      title: "Assignees",
      dataIndex: "assignees",
      width: 180,
      fixed: "left" as const,
      sorter: (first: Project, second: Project) =>
        compareText(
          first.assignees?.map(getAssigneeName).join(", "),
          second.assignees?.map(getAssigneeName).join(", "),
        ),
      render: (assignees: any[], record: Project) => {
        const isOpen = openAssigneeId === record._id;
        const popoverContent = (
          <div style={{ width: 270 }}>
            <div className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-slate-500">Edit Assignees</div>
            <div className="mb-3 max-h-[200px] overflow-y-auto space-y-0.5 pr-0.5">
              {developers.map((dev: any) => {
                const isSelected = tempAssigneeIds.includes(dev._id);
                return (
                  <div
                    key={dev._id}
                    onClick={() =>
                      setTempAssigneeIds((prev) =>
                        isSelected ? prev.filter((id) => id !== dev._id) : [...prev, dev._id],
                      )
                    }
                    className={`flex cursor-pointer items-center gap-2.5 rounded-lg border px-2.5 py-1.5 transition-colors ${
                      isSelected
                        ? "border-emerald-100 bg-emerald-50"
                        : "border-transparent hover:bg-slate-50"
                    }`}
                  >
                    <Avatar
                      size={26}
                      src={dev.photo ? `${PHOTOURL}${dev.photo}` : undefined}
                      className="shrink-0 bg-slate-300"
                    >
                      {(dev.username || "?").charAt(0).toUpperCase()}
                    </Avatar>
                    <span className={`flex-1 text-[13px] ${isSelected ? "font-semibold text-emerald-700" : "text-slate-700"}`}>
                      {dev.username}
                    </span>
                    {isSelected && (
                      <span className="text-[11px] font-bold text-emerald-500">✓</span>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="flex justify-end gap-2">
              <Button size="small" onClick={() => setOpenAssigneeId(null)}>Cancel</Button>
              {hasPermission("projects", "update") && (
                <Button
                  type="primary"
                  size="small"
                  className="bg-slate-900 border-none"
                  onClick={() => handleAssigneeUpdate(record._id, record, tempAssigneeIds)}
                >
                  Save
                </Button>
              )}
            </div>
          </div>
        );
        return (
          <Popover
            open={isOpen}
            onOpenChange={(vis) => {
              if (vis) {
                setOpenAssigneeId(record._id);
                setTempAssigneeIds(record.assignees?.map((a: any) => a._id) || []);
              } else {
                setOpenAssigneeId(null);
              }
            }}
            trigger="click"
            placement="bottomLeft"
            content={popoverContent}
          >
            <button
              type="button"
              className="flex cursor-pointer items-center border-0 bg-transparent p-0"
            >
              {(!assignees || assignees.length === 0) ? (
                <span className="text-slate-400 text-xs italic">Add assignees</span>
              ) : (
                <div className="flex items-center -space-x-1">
                  {assignees.slice(0, 3).map((user) => (
                    <Tooltip key={user._id} title={`${user.username || user.name} — click to edit`}>
                      <Avatar
                        src={user.photo ? `${PHOTOURL}${user.photo}` : undefined}
                        size={30}
                        className="border-2 border-white bg-slate-300 text-slate-700 shadow-sm shrink-0"
                      >
                        {getAssigneeInitial(user)}
                      </Avatar>
                    </Tooltip>
                  ))}
                  {assignees.length > 3 && (
                    <Tooltip title={assignees.slice(3).map((u: any) => u.username || u.name).join(", ")}>
                      <div className="z-10 flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full border-2 border-white bg-slate-100 text-[10px] font-bold text-slate-600 shadow-sm">
                        +{assignees.length - 3}
                      </div>
                    </Tooltip>
                  )}
                </div>
              )}
            </button>
          </Popover>
        );
      },
    },
    {
      title: "Project",
      dataIndex: "projectName",
      width: 240,
      sorter: (first: Project, second: Project) =>
        compareText(first.projectName, second.projectName),
      render: (text: string, record: Project) => {
        const projectName = text || "N/A";
        const showTooltip = projectName.length > 24;
        const startFmt = record.startDate ? dayjs(record.startDate).format("DD MMM YY") : null;
        const targetFmt = record.completionDate ? dayjs(record.completionDate).format("DD MMM YY") : null;

        return (
          <div className="flex min-w-0 flex-col">
            <Tooltip title={showTooltip ? projectName : ""}>
              <span className="block max-w-[210px] truncate text-[13px] font-semibold leading-tight text-slate-800">
                {projectName}
              </span>
            </Tooltip>
            {(startFmt || targetFmt) && (
              <div className="mt-0.5 flex items-center gap-1 text-[10px] leading-tight text-slate-400 whitespace-nowrap">
                {startFmt && (
                  <>
                    <span className="font-medium text-slate-500">Start</span>
                    <span>{startFmt}</span>
                  </>
                )}
                {startFmt && targetFmt && (
                  <span className="text-slate-300">→</span>
                )}
                {targetFmt && (
                  <>
                    <span className="font-medium text-slate-500">Target:</span>
                    <span>{targetFmt}</span>
                  </>
                )}
              </div>
            )}
          </div>
        );
      },
    },
    { title: "Completed On", dataIndex: "endingDate", width: 95,
      sorter: (first: Project, second: Project) =>
        compareDates(first.endingDate, second.endingDate),
      render: (text: any) => (
        <div className="flex items-center gap-1.5 text-slate-500 text-[13px]">
          {text ? (
            <>
              <CalendarOutlined className="text-slate-400 text-xs" />
              {dayjs(text).format("DD MMM YY")}<FaCheckCircle className="text-emerald-500 ml-0.5 text-xs" />
            </>
          ) : (
            <span className="text-slate-300">—</span>
          )}
        </div>
      ),
    },
    {
      title: "Summary",
      key: "summary",
      width: 110,
      align: "center" as const,
      render: (_: any, record: any) => (
        <div className="flex justify-center">
          <button
            onClick={() => handleViewSummary(record._id)}
            className="flex h-[34px] w-[34px] items-center justify-center rounded-lg border border-emerald-100 bg-emerald-50 text-emerald-600 shadow-sm transition-colors hover:bg-emerald-100"
          >
            <RiLayoutGridFill size={17} />
          </button>
        </div>
      ),
    },
    {
      title: "Documents",
      key: "documents",
      width: 120,
      align: "center" as const,
      render: (_: any, record: any) => {
        const count = (record.purposal?.length || 0) + (record.contract?.length || 0);
        return (
          <div className="flex justify-center">
            <div className="relative inline-block">
            <button
              onClick={() => {
                setCurrentTask(record);
                setSelectedDocs({
                  purposal: record.purposal || [],
                  contract: record.contract || [],
                });
                setIsDocModalVisible(true);
              }}
              className="flex h-[34px] w-[34px] items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-500 shadow-sm transition-all hover:border-slate-400 hover:text-slate-700"
            >
              <HiOutlineDocumentText size={18} />
            </button>
            {count > 0 && (
              <span className="absolute -right-2.5 -top-2.5 flex h-5 w-5 items-center justify-center rounded-full border border-slate-200 bg-white text-[11px] font-bold leading-none text-slate-700 shadow-sm">
                {count}
              </span>
            )}
            </div>
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "isActive",
      width: 140,
      sorter: (first: Project, second: Project) =>
        getStatusSortValue(first) - getStatusSortValue(second),
      render: (_: any, record: Project) => <StatusBadge record={record} />,
    },
    {
      title: "Action",
      key: "action",
      width: 130,
      align: "center" as const,
      render: (_: any, record: Project) => (
        <div className="flex items-center justify-center gap-1">
          <Tooltip title="Edit">
            <button
              onClick={() => handleEditClick(record)}
              className="flex h-[34px] w-[34px] items-center justify-center rounded-lg border border-slate-100 bg-white text-slate-500 shadow-sm transition-all hover:border-slate-300 hover:text-slate-700"
            >
              <FaPen size={13} />
            </button>
          </Tooltip>
          <Tooltip title={activeTab === "archived" ? "Delete" : "Archive"}>
            <button
              onClick={() => setDeleteId(record._id)}
              className="flex h-[34px] w-[34px] items-center justify-center rounded-lg border border-slate-100 bg-white text-rose-500 shadow-sm transition-all hover:border-rose-200 hover:bg-rose-50"
            >
              <FaTrashAlt size={13} />
            </button>
          </Tooltip>
          {activeTab === "archived" && (
            <Tooltip title="Restore">
              <button
                onClick={() => setRestoreId(record._id)}
                className="flex h-[34px] w-[34px] items-center justify-center rounded-lg border border-slate-100 bg-white text-emerald-600 shadow-sm transition-all hover:border-emerald-200 hover:bg-emerald-50"
              >
                <MdOutlineRestore size={17} />
              </button>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    autoRegisterCurrentPageColumns(columns);
  }, []);

  const handleDeletedocument = async (doc: string, projectId: string) => {
    try {
      await deleteDocument(projectId, doc);
      message.success("Document deleted successfully");
      fetchProject();
      setSelectedDocs((prev) => ({
        purposal: prev.purposal?.filter((d) => d !== doc),
        contract: prev.contract?.filter((d) => d !== doc),
      }));
    } catch (error: any) {
      console.error(error);
      message.error("Failed to delete document");
    }
  };

  return (
    <div>
      <style>{`
        .ant-table-thead > tr > th {
          background: #f1f5f9 !important;
          color: #374151 !important;
          font-weight: 600 !important;
          font-size: 13px !important;
          text-transform: none !important;
          letter-spacing: 0 !important;
          border-bottom: 1px solid #f1f5f9 !important;
          padding: 20px 12px !important;
          white-space: nowrap !important;
          vertical-align: top !important;
        }
        .ant-table-thead > tr > th:first-child {
          text-align: left !important;
          vertical-align: top !important;
          padding-left: 24px !important;
          border-top-left-radius: 16px !important;
        }
        .ant-table-thead > tr > th:last-child {
          border-top-right-radius: 16px !important;
        }
        .ant-table-tbody > tr > td {
          border-bottom: 1px solid #f1f5f9 !important;
          padding: 14px 12px !important;
          vertical-align: middle !important;
        }
        .ant-table-tbody > tr > td:first-child {
          padding-left: 24px !important;
        }

        .ant-table {
          background: #fff !important;
        }
        .ant-pagination-item-active {
          background-color: #0f172a !important;
          border-color: #0f172a !important;
        }
        .ant-pagination-item-active a {
          color: white !important;
        }
        .custom-project-table .ant-table-container {
          border-radius: 16px 16px 0 0 !important;
          overflow: hidden !important;
        }
        .custom-project-table .ant-table-body,
        .custom-project-table .ant-table-content {
          overflow-x: auto !important;
          scrollbar-color: #dfe4ea transparent;
          scrollbar-width: thin;
        }
        .custom-project-table .ant-table-body::-webkit-scrollbar,
        .custom-project-table .ant-table-content::-webkit-scrollbar {
          height: 5px;
        }
        .custom-project-table .ant-table-body::-webkit-scrollbar-track,
        .custom-project-table .ant-table-content::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-project-table .ant-table-body::-webkit-scrollbar-thumb,
        .custom-project-table .ant-table-content::-webkit-scrollbar-thumb {
          border-radius: 999px;
          background: #dfe4ea;
        }
        .project-page-size-select .ant-select-selector {
          height: 36px !important;
          border-radius: 8px !important;
          border-color: #e2e8f0 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
        }
        .project-page-size-select .ant-select-selection-item {
          display: flex !important;
          align-items: center !important;
          color: #475569 !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          line-height: 34px !important;
        }
        .project-dialog .ant-modal-content {
          display: flex;
          max-height: calc(100vh - 32px);
          flex-direction: column;
          overflow: hidden;
          border-radius: 12px;
          padding: 0;
        }
        .project-dialog .ant-modal-header {
          margin: 0;
          border-bottom: 1px solid #edf1f5;
          padding: 15px 18px 13px;
        }
        .project-dialog .ant-modal-body {
          max-height: calc(100vh - 96px);
          overflow-y: auto;
          padding: 16px 18px 18px;
        }
        .project-dialog .ant-modal-close {
          inset-inline-end: 11px;
          top: 10px;
          height: 32px;
          width: 32px;
        }
        .project-delete-dialog .ant-modal-content {
          max-height: calc(100vh - 32px);
          overflow: hidden;
          border-radius: 12px;
          padding: 0;
        }
        .project-delete-dialog .ant-modal-body {
          padding: 24px 24px 14px;
        }
        .project-delete-dialog .ant-modal-footer {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin: 0;
          padding: 0 24px 22px;
        }
        .project-delete-dialog .ant-modal-footer .ant-btn + .ant-btn {
          margin-inline-start: 0;
        }
        @media (max-width: 1024px) {
          .project-dialog,
          .project-delete-dialog {
            max-width: calc(100vw - 24px) !important;
          }
        }
      `}</style>

      {/* (Header row removed: search + add button moved into tabs row) */}

      {/* Stats Card */}
      <Card className="mb-4">
        <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase", color: "#64748b", marginBottom: 14 }}>
          Project Overview
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 xl:grid-cols-5">
          {[
            {
              label: "Total Projects",
              value: stats.totalProjects,
              icon: <FaBriefcase style={{ fontSize: 20 }} />,
              iconBg: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              percent: 100,
              up: true,
            },
            {
              label: "Active Projects",
              value: stats.activeProjects,
              icon: <BsCheck2Circle style={{ fontSize: 20 }} />,
              iconBg: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
              percent: stats.totalProjects ? Math.round((stats.activeProjects / stats.totalProjects) * 100) : 0,
              up: stats.activeProjects > 0,
            },
            {
              label: "On Hold",
              value: stats.onHoldProjects,
              icon: <FaHourglassHalf style={{ fontSize: 18 }} />,
              iconBg: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
              percent: stats.totalProjects ? Math.round((stats.onHoldProjects / stats.totalProjects) * 100) : 0,
              up: false,
            },
            {
              label: "Completed",
              value: stats.completedProjects,
              icon: <FaFlag style={{ fontSize: 18 }} />,
              iconBg: "linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)",
              percent: stats.totalProjects ? Math.round((stats.completedProjects / stats.totalProjects) * 100) : 0,
              up: stats.completedProjects > 0,
            },
            {
              label: "Archived",
              value: stats.deletedProjects,
              icon: <RiInboxArchiveLine style={{ fontSize: 20 }} />,
              iconBg: "linear-gradient(135deg, #e11d48 0%, #f59e0b 100%)",
              percent: stats.totalProjects ? Math.round((stats.deletedProjects / stats.totalProjects) * 100) : 0,
              up: false,
            },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                borderRadius: 14,
                background: "#f8fafc",
                border: "1px solid #f1f5f9",
                padding: "16px",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600, marginBottom: 6 }}>{item.label}</div>
                  <div style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", lineHeight: 1.1 }}>{item.value}</div>
                </div>
                <div style={{
                  width: 44,
                  height: 44,
                  borderRadius: 12,
                  background: item.iconBg,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  flexShrink: 0,
                }}>
                  {item.icon}
                </div>
              </div>
              <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 4, flexWrap: "wrap" }}>
                {item.up
                  ? <ArrowUpOutlined style={{ color: "#10b981", fontSize: 11 }} />
                  : <ArrowDownOutlined style={{ color: "#ef4444", fontSize: 11 }} />
                }
                <span style={{ color: item.up ? "#10b981" : "#ef4444", fontSize: 12, fontWeight: 500 }}>
                  {item.percent}%
                </span>
                <span style={{ color: "#94a3b8", fontSize: 11 }}>of total</span>
              </div>
            </div>
          ))}
        </div>
      </Card>

      {/* Table Card */}
      <Card className="" bodyStyle={{ padding: 0 }}>
        {/* Tabs + Search + Add button on one row */}
        <div className="px-4 pt-4 pb-3">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="overflow-x-auto">
              <div className="flex w-fit" style={{ border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}>
                {[
                  { key: "active", label: "Active", count: stats.activeProjects },
                  { key: "onhold", label: "On Hold", count: stats.onHoldProjects },
                  { key: "completed", label: "Completed", count: stats.completedProjects },
                  { key: "archived", label: "Archived", count: stats.deletedProjects },
                  { key: "all", label: "All", count: stats.totalProjects },
                ].map((tab, index) => (
                  <button
                    key={tab.key}
                    onClick={() => { setActiveTab(tab.key as any); setPage(1); }}
                    style={{ borderRight: index < 4 ? "1px solid #e5e7eb" : "none" }}
                    className={`flex shrink-0 items-center gap-1.5 px-4 py-2 text-sm font-medium whitespace-nowrap outline-none transition-colors ${
                      activeTab === tab.key
                        ? "bg-[#001529] text-white"
                        : "bg-white text-gray-700 hover:bg-gray-50"
                    }`}
                  >
                    {tab.label}
                    {tab.count !== null && (
                      <span className={`inline-flex items-center justify-center rounded-full px-1.5 py-0.5 text-[10px] font-bold leading-none ${
                        activeTab === tab.key
                          ? "bg-white/20 text-white"
                          : "bg-gray-100 text-gray-600"
                      }`}>
                        {tab.count}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end">
              <Input
                prefix={<SearchOutlined />}
                size="large"
                placeholder="Search projects and clients"
                allowClear
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ width: 220, height: "33px" }}
              />
              <Button
                type="primary"
                onClick={() => setIsModalOpen(true)}
                className="allbuttons"
              >
                <PlusOutlined className="button-icon" />
                <span className="button-text">Add Project</span>
              </Button>
            </div>
          </div>
        </div>

        {/* Issue #3: Drag-and-drop reorder wrapper */}
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="projects-list" direction="vertical">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                <Table
                  columns={columns}
                  dataSource={dataSource}
                  rowKey="_id"
                  loading={loading}
                  pagination={false}
                  scroll={{ x: 1325 }}
                  className="custom-project-table"
                  components={activeTab !== "archived" ? {
                    body: {
                      row: (props: any) => {
                        const index = dataSource.findIndex((d: Project) => d._id === props['data-row-key']);
                        return (
                          <Draggable
                            draggableId={String(props['data-row-key'])}
                            index={index >= 0 ? index : 0}
                          >
                            {(dragProvided, snapshot) => (
                              <tr
                                {...props}
                                ref={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                {...dragProvided.dragHandleProps}
                                style={{
                                  ...props.style,
                                  ...dragProvided.draggableProps.style,
                                  background: snapshot.isDragging ? "#f0f9ff" : undefined,
                                }}
                              />
                            )}
                          </Draggable>
                        );
                      },
                    },
                  } : undefined}
                />
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {/* Footer / Pagination */}
        <div className="flex flex-col items-center justify-between gap-3 border-t border-slate-100 px-4 py-3 sm:flex-row">
          <div className="text-center text-[11px] font-medium text-slate-500 sm:text-left">
            Showing <span className="text-slate-700">{totalRecords ? (page - 1) * pageSize + 1 : 0}</span> to{" "}
            <span className="text-slate-700">{Math.min(page * pageSize, totalRecords)}</span> of{" "}
            <span className="text-slate-700">{totalRecords}</span> projects
          </div>
          <div className="flex w-full flex-wrap items-center justify-center gap-2 sm:w-auto sm:justify-end">
            <Pagination
              current={page}
              total={totalRecords}
              pageSize={pageSize}
              onChange={setPage}
            />
            <Select
              value={pageSize.toString()}
              onChange={(nextPageSize) => {
                setPageSize(Number(nextPageSize));
                setPage(1);
              }}
              options={["10", "20", "40", "50", "100"].map((size) => ({
                value: size,
                label: `${size} / page`,
              }))}
              className="project-page-size-select ml-2 w-[104px]"
            />
          </div>
        </div>
      </Card>

      {/* All Modals */}
      <AddProjectModal
        visible={isModalOpen}
        onTaskCreated={() => {
          setIsModalOpen(false);
          fetchProject();
          fetchStats();
        }}
        onClose={() => setIsModalOpen(false)}
      />

      {currentTask && (
        <EditProjectModal
          visible={isEditModalVisible}
          taskId={currentTask._id}
          onClose={() => setIsEditModalVisible(false)}
          onSuccess={() => {
            setIsEditModalVisible(false);
            fetchProject();
            fetchStats();
          }}
        />
      )}

      {/* Summary Modal */}
      <Modal
        title={
          <span className="flex items-center gap-2 text-[17px] font-semibold text-slate-900">
            <RiLayoutGridFill className="text-emerald-600" />
            Project Summary
          </span>
        }
        centered
        open={isSummaryModalOpen}
        onCancel={() => setIsSummaryModalOpen(false)}
        footer={null}
        width={680}
        destroyOnClose
        className="project-dialog project-summary-dialog"
      >
        <Spin spinning={summaryLoading}>
          <div className="max-h-[230px] overflow-y-auto pr-1">
            {summaryData.length > 0 ? (
              <div className="space-y-2.5">
                {summaryData.map((summary, idx) => (
                  <div key={idx} className="group relative rounded-[8px] border border-slate-200 bg-slate-50 px-3 py-3">
                    <div className="mb-2 flex items-start justify-between gap-3">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded-[6px] border border-slate-200 bg-white px-2 py-1 text-[11px] font-semibold text-slate-700 shadow-sm">
                          {summary.date}
                        </span>
                        {summary.nextActionDate && (
                          <span className="rounded-[6px] border border-amber-100 bg-amber-50 px-2 py-1 text-[10px] font-semibold uppercase text-amber-600">
                            Next: {summary.nextActionDate}
                          </span>
                        )}
                      </div>
                      <button
                        onClick={async () => {
                          try {
                            setSummaryLoading(true);
                            await deleteProjectSummary(currentSummaryprojectId, summary._id);
                            message.success("Summary deleted");
                            const res = await getProjectByID(currentSummaryprojectId || "");
                            setSummaryData(res?.summaries || []);
                            fetchProject();
                          } catch (err) {
                            message.error("Failed to delete summary");
                          } finally {
                            setSummaryLoading(false);
                          }
                        }}
                        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-[6px] border border-slate-200 bg-white text-slate-400 transition-colors hover:border-rose-200 hover:text-rose-500"
                        aria-label="Delete summary"
                      >
                        <DeleteOutlined />
                      </button>
                    </div>
                    <p className="m-0 text-[13px] leading-relaxed text-slate-700">
                      {summary.description}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="rounded-[8px] border border-dashed border-slate-200 py-8 text-center text-[13px] text-slate-400">
                No summaries added yet
              </div>
            )}
          </div>

          <div className="mt-4 border-t border-slate-100 pt-4">
             <h4 className="mb-3 text-[14px] font-semibold text-slate-900">Add New Summary</h4>
             <div className="mb-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
                <DatePicker
                  placeholder="Summary Date"
                  value={newSummary.date}
                  onChange={(val) => setNewSummary({ ...newSummary, date: val })}
                  className="h-9 w-full rounded-[7px] border-slate-200"
                  getPopupContainer={(trigger) => trigger.parentElement!}
                />
                <DatePicker
                  placeholder="Next Action Date"
                  value={newSummary.nextActionDate}
                  onChange={(val) => setNewSummary({ ...newSummary, nextActionDate: val })}
                  className="h-9 w-full rounded-[7px] border-slate-200"
                  getPopupContainer={(trigger) => trigger.parentElement!}
                />
             </div>
             <Input.TextArea
                rows={3}
                placeholder="Describe the latest project status..."
                value={newSummary.description}
                onChange={(e) => setNewSummary({ ...newSummary, description: e.target.value })}
                className="mb-3 rounded-[7px] border-slate-200"
             />
             <div className="flex justify-end gap-2">
                <Button onClick={() => setIsSummaryModalOpen(false)} className="h-9 rounded-[7px] border-slate-200 px-5 text-[13px] font-semibold">
                  Cancel
                </Button>
                <Button
                  type="primary"
                  className="h-9 rounded-[7px] border-none bg-slate-900 px-5 text-[13px] font-semibold hover:!bg-slate-900"
                  onClick={async () => {
                    if (!newSummary.description?.trim()) return message.error("Please enter a description");
                    try {
                      setSummaryLoading(true);
                      const formData = new FormData();
                      formData.append("newSummary", JSON.stringify({
                        description: newSummary.description,
                        date: newSummary.date?.format("DD MMM YYYY"),
                        nextActionDate: newSummary.nextActionDate?.format("DD MMM YYYY"),
                      }));
                      await updateProject(currentSummaryprojectId || "", formData, user_id);
                      message.success("Summary added");
                      const res = await getProjectByID(currentSummaryprojectId || "");
                      setSummaryData(res?.summaries || []);
                      setNewSummary({ date: dayjs(), description: "", nextActionDate: dayjs() });
                      fetchProject();
                    } catch (err) {
                      message.error("Failed to add summary");
                    } finally {
                      setSummaryLoading(false);
                    }
                  }}
                >
                  Save Summary
                </Button>
             </div>
          </div>
        </Spin>
      </Modal>

      {/* Document Modal */}
      <Modal
        open={isDocModalVisible}
        onCancel={() => setIsDocModalVisible(false)}
        footer={null}
        width={680}
        title={
          <span className="flex items-center gap-2 text-[17px] font-semibold text-slate-900">
            <HiOutlineDocumentText className="text-slate-600" />
            Project Documents
          </span>
        }
        className="project-dialog project-documents-dialog"
      >
        <div className="flex flex-col gap-4">
          {((selectedDocs.purposal?.length || 0) + (selectedDocs.contract?.length || 0)) > 0 ? (
            <>
              {selectedDocs.purposal && selectedDocs.purposal.length > 0 && (
                <div>
                  <h3 className="mb-2 px-1 text-[12px] font-semibold uppercase text-slate-500">Proposals</h3>
                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {selectedDocs.purposal.map((doc, i) => (
                      <div key={i} className="group relative cursor-pointer rounded-[8px] border border-slate-200 bg-slate-50 p-3 transition-colors hover:border-slate-300"
                        onClick={() => window.open(`${process.env.REACT_APP_IMAGE_URL}/projects/${doc}`, '_blank')}
                      >
                        <div className="flex items-center gap-3">
                          <div className="rounded-[6px] border border-slate-100 bg-white p-2 shadow-sm">
                            <FilePdfOutlined className="text-rose-500 text-lg" />
                          </div>
                          <div className="flex flex-col min-w-0">
                            <span className="text-[13px] font-bold text-slate-700 truncate">{doc.split('-').pop()}</span>
                            <span className="text-[10px] font-medium text-slate-400">PDF Document</span>
                          </div>
                        </div>
                        <button
                          onClick={(e) => { e.stopPropagation(); handleDeletedocument(doc, currentTask?._id || "") }}
                          className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full border border-slate-200 bg-white text-rose-500 opacity-0 shadow-sm transition-all hover:bg-rose-50 group-hover:opacity-100"
                        >
                          <DeleteOutlined className="text-[10px]" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {selectedDocs.contract && selectedDocs.contract.length > 0 && (
                <div>
                  <h3 className="mb-2 px-1 text-[12px] font-semibold uppercase text-slate-500">Contracts & NDAs</h3>
                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    {selectedDocs.contract.map((doc, i) => (
                      <div key={i} className="group relative cursor-pointer rounded-[8px] border border-slate-200 bg-slate-50 p-3 transition-colors hover:border-slate-300"
                        onClick={() => window.open(`${process.env.REACT_APP_IMAGE_URL}/projects/${doc}`, '_blank')}
                      >
                        <div className="flex items-center gap-3">
                          <div className="rounded-[6px] border border-slate-100 bg-white p-2 shadow-sm">
                            <FileOutlined className="text-blue-500 text-lg" />
                          </div>
                          <div className="flex flex-col min-w-0">
                            <span className="text-[13px] font-bold text-slate-700 truncate">{doc.split('-').pop()}</span>
                            <span className="text-[10px] font-medium text-slate-400">Word/Doc</span>
                          </div>
                        </div>
                        <button
                          onClick={(e) => { e.stopPropagation(); handleDeletedocument(doc, currentTask?._id || "") }}
                          className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full border border-slate-200 bg-white text-rose-500 opacity-0 shadow-sm transition-all hover:bg-rose-50 group-hover:opacity-100"
                        >
                          <DeleteOutlined className="text-[10px]" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="flex flex-col items-center justify-center gap-2 rounded-[8px] border border-dashed border-slate-200 py-9 text-slate-400">
              <FileOutlined className="text-3xl opacity-40" />
              <span className="text-[13px] font-medium">No documents uploaded for this project</span>
            </div>
          )}

          {/* Issue #1: Upload new Proposals */}
          {hasPermission("projects", "update") && (
            <div className="mt-2 border-t border-slate-100 pt-3">
              <h3 className="mb-2 px-1 text-[12px] font-semibold uppercase text-slate-500">
                Add Proposals (PDF)
              </h3>
              <Upload
                multiple
                accept=".pdf"
                fileList={newPurposalFiles}
                beforeUpload={() => false}
                onChange={({ fileList }) => setNewPurposalFiles(fileList)}
                onRemove={(file) => {
                  setNewPurposalFiles((prev) => prev.filter((f) => f.uid !== file.uid));
                }}
              >
                <Button icon={<PlusOutlined />} className="h-8">
                  Add Proposal Files
                </Button>
              </Upload>
            </div>
          )}

          {/* Issue #1: Upload new Contracts & NDAs */}
          {hasPermission("projects", "update") && (
            <div className="mt-3">
              <h3 className="mb-2 px-1 text-[12px] font-semibold uppercase text-slate-500">
                Add Contracts & NDAs (PDF/DOC)
              </h3>
              <Upload
                multiple
                accept=".pdf,.doc,.docx"
                fileList={newContractFiles}
                beforeUpload={() => false}
                onChange={({ fileList }) => setNewContractFiles(fileList)}
                onRemove={(file) => {
                  setNewContractFiles((prev) => prev.filter((f) => f.uid !== file.uid));
                }}
              >
                <Button icon={<PlusOutlined />} className="h-8">
                  Add Contract Files
                </Button>
              </Upload>
            </div>
          )}
        </div>

        {/* Issue #1: Save Documents footer */}
        {hasPermission("projects", "update") && (newPurposalFiles.length > 0 || newContractFiles.length > 0) && (
          <div className="mt-4 flex justify-end gap-2 border-t border-slate-100 pt-3">
            <Button
              onClick={() => {
                setNewPurposalFiles([]);
                setNewContractFiles([]);
              }}
              className="h-9 rounded-[7px] px-4 text-[13px] font-semibold"
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleSaveDocuments}
              className="h-9 rounded-[7px] bg-emerald-600 px-5 text-[13px] font-semibold hover:!bg-emerald-600"
            >
              Save Documents
            </Button>
          </div>
        )}
      </Modal>

      {/* Delete Confirmation */}
      <Modal
        open={!!deleteId}
        onOk={handleDelete}
        onCancel={() => setDeleteId(null)}
        okText={activeTab === "archived" ? "Delete Project" : "Archive Project"}
        cancelText="Cancel"
        centered
        width={420}
        okButtonProps={{ className: "h-9 rounded-[7px] border-none bg-rose-600 px-5 text-[13px] font-semibold hover:!bg-rose-600" }}
        cancelButtonProps={{ className: "h-9 rounded-[7px] border-slate-200 px-5 text-[13px] font-semibold" }}
        className="project-delete-dialog"
      >
        <div className="flex flex-col items-center py-1 text-center">
          <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-rose-50">
             {activeTab === "archived" ? (
               <DeleteOutlined className="text-[21px] text-rose-500" />
             ) : (
               <RiInboxArchiveLine className="text-[23px] text-rose-500" />
             )}
          </div>
          <h3 className="mb-1.5 text-[18px] font-semibold text-slate-900">
            {activeTab === "archived"
              ? "Delete this project?"
              : "Archive this project?"}
          </h3>
          <p className="m-0 max-w-[320px] text-[13px] leading-relaxed text-slate-500">
            {activeTab === "archived"
              ? "This action cannot be undone. This will permanently delete the project and all associated data."
              : "The project will move to Archived. You can restore it later."}
          </p>
        </div>
      </Modal>

      {/* Restore Confirmation */}
      <Modal
        open={!!restoreId}
        onOk={handleRestore}
        onCancel={() => setRestoreId(null)}
        okText="Restore Project"
        cancelText="Cancel"
        centered
        width={420}
        okButtonProps={{ className: "h-9 rounded-[7px] border-none bg-emerald-600 px-5 text-[13px] font-semibold hover:!bg-emerald-600" }}
        cancelButtonProps={{ className: "h-9 rounded-[7px] border-slate-200 px-5 text-[13px] font-semibold" }}
        className="project-delete-dialog"
      >
        <div className="flex flex-col items-center py-1 text-center">
          <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50">
            <MdOutlineRestore className="text-[24px] text-emerald-600" />
          </div>
          <h3 className="mb-1.5 text-[18px] font-semibold text-slate-900">
            Restore this project?
          </h3>
          <p className="m-0 max-w-[320px] text-[13px] leading-relaxed text-slate-500">
            The project will return to its previous status.
          </p>
        </div>
      </Modal>

    </div>
  );
};

const Pagination = ({ current, total, pageSize, onChange }: any) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className="flex items-center gap-1.5">
      <button
        onClick={() => current > 1 && onChange(current - 1)}
        disabled={current === 1}
        className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-600 transition-all hover:border-slate-300 hover:text-slate-800 disabled:cursor-not-allowed disabled:text-slate-300"
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
      </button>

      <button
        className="h-9 w-9 rounded-lg bg-slate-900 text-[13px] font-bold text-white shadow-lg"
      >
        {current}
      </button>

      <button
        onClick={() => current < totalPages && onChange(current + 1)}
        disabled={current === totalPages}
        className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 text-slate-600 transition-all hover:border-slate-300 hover:text-slate-800 disabled:cursor-not-allowed disabled:text-slate-300"
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
      </button>
    </div>
  );
};

export const PROJECT_TABLE_COLUMNS = [
  "clientId",
  "assignees",
  "projectName",
  "startDate",
  "completionDate",
  "endingDate",
  "isActive",
];
// ============================================
